import { parse } from "graphql";
export const verifyPayPalMutation = ({
  verificationCode
}) => {
  let schema = "$paypalAccount: String!";
  let type = "paypalAccount: $paypalAccount";
  if (verificationCode) {
    schema += " $verificationCode: String";
    type += " verificationCode: $verificationCode";
  }
  return parse(`
        mutation verifyPaypalAccount(${schema}) {
            verifyPaypalAccount(${type}) {
                activityControlDefault
                address1
                address2
                answerCount
                balance
                balanceCurrency
                balanceCurrencySymbol
                balanceFeeEnabled
                balancePointEnabled
                country
                created
                custRating
                custScoreMsgCount
                custScoreSum
                devices {
                    created
                    lastUsed
                    type
                }
                dob
                email
                firstName
                gender
                groups {
                    tenantName
                    groupName
                    displayName
                }
                language
                lastActive
                lastContactDate
                lastContactDateMobileNotification
                lastLogin
                lastMobileAppVersionUsed
                lastName
                lastRespondDate
                lastReviewDate
                lastWebAppVersionUsed
                loginCount
                note
                picture
                points
                postalCode
                primaryContactNumber
                receiveEmailMarketing
                receiveEmailTaskNotifications
                receiveMobileTaskNotifications
                receiveServiceEmails
                receiveThirdPartyEmails
                replyPreview
                shareNameEmail
                socialSecurityNo
                suggestedAnswerEnabled
                termsAgreeDate
                town
                updated
                updatedBy
                userId
                userName
                userRole
                userSource
                userType
                viewRespAuth
                paypalAccount
                mgsPendingFeeAllocation
                verificationRequired {
                    fields
                }
                paypalVerificationCodeExpiry
            }
        }
    `);
};